export default __webpack_public_path__ + "static/Park.Price_flags_social-bb2487e5f1327b43f76d9eee6529565e.jpg";